const languageMixins = {
  computed: {
    arabic() {
      return this.$store.state.language === 'ar';
    },

    language() {
      return this.$store.state.language;
    },

    i18n() {
      return this.$store.state.i18n[this.$store.state.language];
    },
  },
  methods: {},
};

export default languageMixins;
